import {
  AUDIOBOOK_ID_COOKIE_MAX_AGE_DAYS,
  TOKEN_COOKIE_MAX_AGE_DAYS,
} from 'src/config/Const';
import {
  AUDIOBOOK_ID_COOKIE_NAME,
  AUTH_TOKEN_COOKIE_NAME,
  COOKIE_DOMAIN,
  LOGIN_TOKEN_SUCCEED_COOKIE_NAME,
} from 'src/utils/env';
import { GetServerSidePropsContext } from 'next';
import Cookies from 'cookies';

const date = new Date();

// The auth token is a token string used to authenticate the user.
// It is stored in a cookie and is used across different applications.
export const setAuthTokenServerSide = (
  token: string,
  context: GetServerSidePropsContext
): void => {
  const { req, res } = context;
  const cookies = new Cookies(req, res);
  date.setDate(date.getDate() + TOKEN_COOKIE_MAX_AGE_DAYS);
  cookies.set(AUTH_TOKEN_COOKIE_NAME, token, {
    domain: COOKIE_DOMAIN,
    expires: date,
    httpOnly: false,
  });
};

export const setLoginTokenSucceed = (
  succeed: boolean,
  context: GetServerSidePropsContext
): void => {
  const { req, res } = context;
  const cookies = new Cookies(req, res);
  date.setDate(date.getDate() + TOKEN_COOKIE_MAX_AGE_DAYS);

  cookies.set(LOGIN_TOKEN_SUCCEED_COOKIE_NAME, String(succeed), {
    domain: COOKIE_DOMAIN,
    expires: succeed ? date : undefined,
    httpOnly: false,
  });
};

export const getLoginTokenSucceed = (
  context: GetServerSidePropsContext
): string | undefined => {
  const { req, res } = context;
  const cookies = new Cookies(req, res);
  return cookies.get(LOGIN_TOKEN_SUCCEED_COOKIE_NAME);
};

export const setAudiobookIdServerSide = (
  audiobook_id: string,
  context: GetServerSidePropsContext
): void => {
  const { req, res } = context;
  const cookies = new Cookies(req, res);
  date.setDate(date.getDate() + AUDIOBOOK_ID_COOKIE_MAX_AGE_DAYS);
  cookies.set(AUDIOBOOK_ID_COOKIE_NAME, audiobook_id, {
    domain: COOKIE_DOMAIN,
    expires: date,
    httpOnly: false,
  });
};

export const getAudiobookId = (
  context: GetServerSidePropsContext
): string | undefined => {
  const { req, res } = context;
  const cookies = new Cookies(req, res);
  return cookies.get(AUDIOBOOK_ID_COOKIE_NAME);
};
